/**
 * ป้ายซิมใน dropdown ของฟอร์มการเช่า (สร้าง/แก้ไข) และที่อื่นที่ต่อ "เบอร์ - ค่าย (ประเภท)" — ที่เดียว
 *
 * R4U-3 (รอบพิสูจน์ที่ 4, 8 ก.ย. 2026): ฟอร์มการเช่าประกอบป้ายด้วย template literal
 * `${phone_number} - ${operator} (${type})` ตรง ๆ → ซิมที่ `operator` ว่าง (บน dev มีจริง 3 เบอร์แรก
 * ของ picker) ขึ้น "0991330005 - null (รายเดือน)" — class เดียวกับ R3U-06 ("S/N: null") ที่
 * `deviceOptionLabel` แก้ให้เครื่องแล้ว แต่ฝั่งซิมไม่ครอบ
 *
 * กติกา:
 * - ชื่อหลัก = เบอร์โทร (fallback รหัสซิม แล้ว #id)
 * - ส่วนค่าย (" - AIS") แสดง**เฉพาะเมื่อมีค่าจริง** (ไม่ใช่ null/undefined/ว่าง) · ใส่ `operatorFallback`
 *   ถ้าจอนั้นอยากเห็นคำว่า "ไม่ระบุค่าย" แทนการซ่อน
 * - ส่วนประเภท (" (รายเดือน)") แสดงเฉพาะเมื่อมี `sim_type` — แปลไทยผ่าน `getSimTypeLabel`
 * - ห้ามมีคำว่า null/undefined โผล่ในป้ายทุกกรณี
 */
import { getSimTypeLabel } from './simHelpers';

export interface SimLabelSource {
  id?: number;
  code?: string | null;
  phone_number?: string | null;
  operator?: string | null;
  sim_type?: string | null;
}

export interface SimLabelOptions {
  /** คำที่ใช้แทนค่ายเมื่อว่าง (เช่น 'ไม่ระบุค่าย') — ไม่ใส่ = ซ่อนส่วนค่ายไปเลย */
  operatorFallback?: string;
  /** false = ไม่ต่อท้ายประเภทซิม (ค่าเริ่มต้น true) */
  withType?: boolean;
}

const clean = (v: unknown): string => (v === null || v === undefined ? '' : String(v).trim());

/** ค่ายมือถือแบบสะอาด — คืน null เมื่อว่าง ให้ผู้เรียกซ่อนทั้งส่วน */
export const simOperatorText = (operator?: string | null): string | null => {
  const s = clean(operator);
  return s ? s : null;
};

export function simOptionLabel(sim: SimLabelSource, options: SimLabelOptions = {}): string {
  const { operatorFallback, withType = true } = options;
  const phone = clean(sim.phone_number);
  const primary =
    phone || clean(sim.code) || (typeof sim.id === 'number' ? `#${sim.id}` : 'ซิมการ์ด');

  let label = primary;
  const operator = simOperatorText(sim.operator) ?? (operatorFallback ? clean(operatorFallback) : '');
  if (operator) label += ` - ${operator}`;

  if (withType) {
    const type = clean(sim.sim_type);
    if (type) label += ` (${getSimTypeLabel(type)})`;
  }
  return label;
}
